import { defineStore } from 'pinia'
import { ref, computed } from 'vue'
import { api, setAuthToken } from '@/services/api'
import { useRouter } from 'vue-router'

export const useAuthStore = defineStore('auth', () => {
    const router = useRouter()
    const user = ref(null)
    const token = ref(localStorage.getItem('auth_token'))

    const isAuthenticated = computed(() => !!user.value)
    //const userRole = computed(() => user.value?.role?.name || null)
    const userPermissions = computed(() => user.value?.permissions || [])

    // Vérifier une permission
    const hasPermission = (permission) => {
        return userPermissions.value.includes(permission)
    }

    const hasAnyPermission = (permissions) => {
        return permissions.some(p => userPermissions.value.includes(p))
    }

    const hasRole = (roleName) => user.value?.role?.name === roleName

    const isAdmin = () => hasRole('admin')
    const isModo = () => hasRole('moderator')
    const isMember = () => hasRole('member')

    const login = async (newToken) => {
        // Sauvegarder le token
        token.value = newToken
        setAuthToken(newToken)

        try {
            // Récupérer les infos utilisateur
            const response = await api.get('/api/me')
            user.value = response.data.user
            return true
        } catch (error) {
            console.error('Erreur login:', error)
            logout()
            return false
        }
    }

    const logout = async () => {
        try {
            await api.post('/api/logout')
        } catch (error) {
            console.error('Erreur logout:', error)
        } finally {
            user.value = null
            token.value = null
            setAuthToken(null)
            router.push('/auth/login')
        }
    }

    const fetchUser = async () => {
        if (!token.value) return false

        try {
            const response = await api.get('/api/me')
            user.value = response.data.user
            return true
        } catch (error) {
            console.error('Erreur fetch user:', error)
            logout()
            return false
        }
    }

    return {
        user,
        token,
        isAuthenticated,
        login,
        logout,
        fetchUser,
        hasPermission,
        hasAnyPermission,
        isAdmin,
        isModo,
        isMember,
    }
})
